<se-fe-grid seFeGridOpts="snug">
  <se-fe-grid-cell seFeGridOpts="1/1@mobile">
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts="1/2@mobile" class="preview-block-header">
        <p [translate]="'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.title'"></p>
      </se-fe-grid-cell>
      @if (!dueInFull) {
<se-fe-grid-cell seFeGridOpts="1/2@mobile">
        <se-fe-grid seFeGridOpts="right">
          <se-fe-grid-cell seFeGridOpts="shrink@mobile">
            <span seFePopoverTrigger="popover"></span>
            <se-fe-popover seFePopoverName="popover">
              <p [innerHTML]="'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.EXAMPLE.link | translate'"></p>
              <div class="popover-text" [innerHTML]="'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.EXAMPLE.popover' | translate"></div>
            </se-fe-popover>
          </se-fe-grid-cell>
        </se-fe-grid>
      </se-fe-grid-cell>
}
    </se-fe-grid>
  </se-fe-grid-cell>
  <se-fe-grid-cell seFeGridOpts="1/1@mobile">
    <se-fe-block seFeDataType="outline"  class="se-block--condensed se-block--no-margin">
      <se-fe-grid seFeGridOpts>
        <se-fe-grid-cell seFeGridOpts="grow@mobile">
          <span seFePopoverTrigger="popoverPayment"><strong [translate]="'PAYMENT_TERMS_SELECTOR.TITLES.upfront_payment'"></strong></span>
          <span>
            <se-fe-popover seFePopoverName="popoverPayment">
              @if (dueInFull) {
<div
                class="popover-text"
                [innerHTML]="'PAYMENT_TERMS_SELECTOR.UPFRONT_PAYMENT.POPOVER.due_in_full' | translate">
              </div>
}
              @if (!dueInFull) {
<div
                class="popover-text"
                [innerHTML]="'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.UPFRONT_PAYMENT.POPOVER.default' | translate">
              </div>
}
            </se-fe-popover>
          </span>
          <br>
          <small [translate]="'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.due_upfront'"></small>
        </se-fe-grid-cell>
        <se-fe-grid-cell seFeGridOpts="shrink@mobile">
          @if (dueInFull) {
<strong [translate]="'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.AMOUNTS.due_in_full'"></strong>
}
          @if (!dueInFull) {
<strong [translate]="'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.AMOUNTS.upfront_payment'"></strong>
}
        </se-fe-grid-cell>
      </se-fe-grid>
    </se-fe-block>
  </se-fe-grid-cell>

  <se-fe-grid-cell seFeGridOpts="1/1@mobile">
    @if (previewPercentages.length) {
<se-fe-block seFeDataType="outline"  class="se-block--condensed se-block--no-margin">
      @if (hasCustomDates) {
<app-custom-dates-selector

        [paymentTermForm]="paymentTermForm"
        [saleType]="saleType">
      </app-custom-dates-selector>
}

      @if (!hasCustomDates) {
<div>
        @for (percentage of previewPercentages; track percentage; let i = $index) {
<se-fe-grid seFeGridOpts>
          <se-fe-grid-cell seFeGridOpts="grow@mobile">
            <strong
              [translate]="'PAYMENT_TERMS_SELECTOR.TITLES.installment'"
              [translateParams]="{ index: i + 1 }">
            </strong>
            <br>
            <small>
              @if (dueDateParams['interval']) {
<span>
                @if (i === 0) {
<span>
                  {{
                  'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.WINDOW_DUE_DATES.'+installmentWindow+'_first_installment' |
                    pluralizeKey:dueDateParams['interval'] |
                    translate:dueDateParams
                  }}
                </span>
}
                @if (i) {
<span>
                  {{
                  'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.WINDOW_DUE_DATES.'+installmentWindow |
                    pluralizeKey:dueDateParams['interval'] |
                    translate:dueDateParams
                  }}
                </span>
}
              </span>
}
              @if (!dueDateParams['interval']) {
<span>
                @if (i === 0) {
<span>
                  {{ 'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.WINDOW_DUE_DATES.'+installmentWindow+'_first_installment' | translate:dueDateParams }}
                </span>
}
                @if (i) {
<span>
                  {{ 'PAYMENT_TERMS_SELECTOR.TERM_PREVIEW.WINDOW_DUE_DATES.'+installmentWindow | translate:dueDateParams }}
                </span>
}
              </span>
}
            </small>
          </se-fe-grid-cell>
          <se-fe-grid-cell seFeGridOpts="shrink@mobile">
            <strong>{{ percentage }}%</strong>
          </se-fe-grid-cell>
        </se-fe-grid>
}
      </div>
}
    </se-fe-block>
}
  </se-fe-grid-cell>
</se-fe-grid>
